<template>
  <v-layout row wrap ma-0>
    <template v-for="(item, index) in dataSource">
      <v-flex
        v-if="index % 2 === 0"
        :key="`form-${index}`"
        :class="{
          xs6: $vuetify.breakpoint.width >= 400,
          'pr-1': $vuetify.breakpoint.width >= 400,
          xs12: $vuetify.breakpoint.width < 400
        }"
        sm6
        mt-2
      >
        <p class="body-2 font-weight-medium mb-1 d-flex align-self-center">
          {{ item[textName] }}
        </p>
        <v-text-field
          v-model="formValue[item[textModel]]"
          hide-details
          class="card-border"
          :clearable="!readonly"
          my-auto
          solo
          flat
          :readonly="readonly"
        ></v-text-field>
      </v-flex>
      <v-flex
        v-else
        :key="`form-${index}`"
        :class="{
          xs6: $vuetify.breakpoint.width >= 400,
          'pl-1': $vuetify.breakpoint.width >= 400,
          xs12: $vuetify.breakpoint.width < 400,
          'mt-2': $vuetify.breakpoint.width < 400
        }"
        sm6
        mt-2
      >
        <p class="body-2 font-weight-medium mb-1 d-flex align-self-center">
          {{ item[textName] }}
        </p>
        <v-text-field
          v-model="formValue[item[textModel]]"
          hide-details
          class="card-border"
          :clearable="!readonly"
          my-auto
          solo
          flat
          :readonly="readonly"
        ></v-text-field>
      </v-flex>
    </template>
  </v-layout>
</template>

<script>
export default {
  name: 'DoubleColumnForm',
  data: () => ({
    formValue: {}
  }),
  props: {
    dataSource: {
      type: Array,
      default() {
        return [];
      }
    },
    textName: {
      type: String,
      default: 'name'
    },
    textValue: {
      type: String,
      default: 'value'
    },
    textModel: {
      type: String,
      default: 'model'
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  created() {
    // this.getForm();
  },
  mounted() {
    this.initValue();
  },
  methods: {
    initValue() {
      this.dataSource.forEach(item => {
        this.formValue[item[this.textModel]] = item[this.textValue];
      });
    }
    // getForm() {}
  },
  computed: {},
  watch: {
    formValue(newValue) {
      this.$emit('input', newValue);
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 0;
  background-color: white;
}

// .card-border {
//   margin-top: 4px;
// }

// .v-text-field {
//   height: 40px;
// }

.headline {
  color: #ba4438;
  border-bottom: 1px solid #ededed;
  p {
    font-size: 18px;
  }
}
</style>
